var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailValidationSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 138,
    viewBox: "0 0 131 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 74V11C128 6.58172 124.418 3 120 3H11C6.58172 3 3 6.58172 3 11V74C3 78.4183 6.58172 82 11 82H120C124.418 82 128 78.4183 128 74Z",
    stroke: "#121212",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4L65.6388 48.3477C65.9888 48.608 66.4671 48.6114 66.8208 48.3561L125.5 6",
    stroke: "#121212",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 67.6803L52.4189 40.7908",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.66 69.6558C113.752 70.5019 115.322 70.3034 116.168 69.2123C117.014 68.1212 116.816 66.5508 115.725 65.7047L112.66 69.6558ZM115.725 65.7047L80.1141 38.0884L77.05 42.0395L112.66 69.6558L115.725 65.7047Z",
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104L66 121",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94V114",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94V114",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94H67",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 131V135",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailValidationSent);
export default __webpack_public_path__ + "static/media/mailValidationSent.01b73d92160623f50cde421b4e27474c.svg";
export { ForwardRef as ReactComponent };